<template>
  <div id="app-main">
    <div class="row">
      <div class="col">
        <div class="page-title-box">
          <h4 class="page-title">课程列表</h4>
        </div>
      </div>
    </div>
    <div class="row flex-between">
      <div class="col-2 mb-3 flex">
        <b-form-select
          class="selectbox"
          v-model="termSelected"
          :options="termOptions"
        ></b-form-select>
        <b-form-select
          class="selectbox"
          v-model="collegeSelected"
          :options="collegeOptions"
        ></b-form-select>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-card>
          <div class="row mb-3 flex-between">
            <div class="col-2">
              <b-button variant="primary">导出表格</b-button>
            </div>
            <div class="col-2">
              <b-form-select
                class="selectbox"
                v-model="termSelected"
                :options="termOptions"
              ></b-form-select>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <b-table
                :items="items"
                :fields="fields"
                :striped="striped"
                :current-page="currentPage"
                :per-page="perPage"
                show-empty
              >
                <template #cell(ful)="row">
                  <a href="javascript:void(0)">{{ row.value }}</a>
                </template>
              </b-table>
            </div>
          </div>
          <a href=""></a>
          <div class="row flex-end">
            <Pagination></Pagination>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>
<script>
import Pagination from '@/components/Pagination.vue'

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      rows: 10,
      termSelected: -1,
      termOptions: [
        { value: '-1', text: '全部学期' },
        { value: '1', text: '16-17上学期' },
        { value: '2', text: '16-17下学期' },
      ],
      collegeSelected: -1,
      collegeOptions: [
        { value: '-1', text: '所有课程' },
        { value: '1', text: '教育科学学院' },
        { value: '2', text: '教育科学学院16-17上' },
      ],
      fields: [
        {
          key: 'id',
          label: '课程ID',
        },
        {
          key: 'cat',
          label: '课程类别',
        },
        {
          key: 'ful',
          label: '课程全称',
        },
        {
          key: 'sim',
          label: '课程简称',
        },
        {
          key: 'start',
          label: '开始时间',
        },
        {
          key: 'end',
          label: '结束时间',
        },
        {
          key: 'tea',
          label: '任课教师',
        },
        {
          key: 'jud',
          label: '判断依据',
        },
      ],
      items: [
        {
          id: 1,
          cat: '类别',
          ful: '课程全程课程全程课程全程课程全程课程全程课程全程课程全程课程全程课程全程',
          sim: '课程简称',
          start: '04.12',
          end: '08.12',
          tea: '教师名',
          jud: '判断依据',
        },
        {
          id: 2,
          cat: '类别',
          ful: '课程全程课程全程课程全程课程全程课程全程课程全程课程全程课程全程课程全程',
          sim: '课程简称',
          start: '04.12',
          end: '08.12',
          tea: '教师名',
          jud: '判断依据',
        },
        {
          id: 3,
          cat: '类别',
          ful: '课程全程课程全程课程全程课程全程课程全程课程全程课程全程课程全程课程全程',
          sim: '课程简称',
          start: '04.12',
          end: '08.12',
          tea: '教师名',
          jud: '判断依据',
        },
        {
          id: 4,
          cat: '类别',
          ful: '课程全程课程全程课程全程课程全程课程全程课程全程课程全程课程全程课程全程',
          sim: '课程简称',
          start: '04.12',
          end: '08.12',
          tea: '教师名',
          jud: '判断依据',
        },
        {
          id: 5,
          cat: '类别',
          ful: '课程全程课程全程课程全程课程全程课程全程课程全程课程全程课程全程课程全程',
          sim: '课程简称',
          start: '04.12',
          end: '08.12',
          tea: '教师名',
          jud: '判断依据',
        },
        {
          id: 6,
          cat: '类别',
          ful: '课程全程课程全程课程全程课程全程课程全程课程全程课程全程课程全程课程全程',
          sim: '课程简称',
          start: '04.12',
          end: '08.12',
          tea: '教师名',
          jud: '判断依据',
        },
        {
          id: 7,
          cat: '类别',
          ful: '课程全程课程全程课程全程课程全程课程全程课程全程课程全程课程全程课程全程',
          sim: '课程简称',
          start: '04.12',
          end: '08.12',
          tea: '教师名',
          jud: '判断依据',
        },
      ],
      striped: true,
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15, { value: 100, text: 'Show a lot' }],
    }
  },
  methods: {
    courseDetail() {
      this.$router.push({
        path: '/courseDetail',
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.page-title-box {
  h4.page-title {
    font-weight: 600;
  }
}
.selectbox {
  margin-right: 11px;
}
.empty-course {
  height: 320px;
  background-color: white;
  background-repeat: no-repeat;
  background-clip: content-box;
  .empty-course-tips {
    margin-top: 24px;
    color: rgba(152, 166, 173, 1);
    font-size: 18px;
  }
}
.course-card {
  cursor: pointer;
  .cover-img {
    width: 100%;
    height: 0;
    padding-bottom: 55.4%;
    overflow: hidden;
    background-image: url('~@/assets/images/course/course-cover.png');
    background-size: cover;
    background-repeat: no-repeat;
  }
  .course-name {
    margin-top: 24px;
    color: rgba(52, 58, 64, 1);
    font-size: 18px;
    line-height: 18px;
    font-weight: bold;
  }
  .teacher-name {
    margin-top: 16px;
    color: rgba(152, 166, 173, 1);
    font-size: 14px;
    line-height: 14px;
  }
}
</style>
